export const ACCOUNT_LIST_PATH = "/accounts";
export const ACCOUNT_DETAIL_VIEW_PATH = "/accounts/:accountUuid/:principalUuid";
export const ACCOUNT_CREATE_VIEW_PATH = "/accounts/create";
export const ACCOUNT_EDIT_VIEW_PATH: string =
  "/accounts/:accountUuid/:principalUuid/edit";
